import { useState, useEffect, useRef } from "react";
import { APIProvider, useMapsLibrary } from '@vis.gl/react-google-maps';
import Swal from "sweetalert2";

import {
    Col
} from "reactstrap";

const API_KEY = "AIzaSyCXONdJ6W5hndXH0ivRXCR3MbUMO4JXHdw";

function Autocompletion(props) {
    const { data, modelFctManager, parentProps, childShouldRerender, defaultCountry } = props;//formManager bindPropResult isConfiguration parentDisabled

    const places = useMapsLibrary('places');
    const autocompletionInput = useRef(null);
    const [shouldRender, setShouldRender] = useState(false);
    const [addressAutocompletion, setAddressAutocompletion] = useState(null);

    // Constantes Internes :
    const args = data.argumentsObj;
    const optionLocation = (args?.optionLocation) ? args.optionLocation : ['street_address'];
    const countries = (defaultCountry) ? ((defaultCountry === "*") ? [] : [defaultCountry]) : ((args?.countries) ? args.countries : ['FR']);
    // Effects : 
    useEffect(() => {
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }

        if ((!data.children || data.children.length === 0) && modelFctManager?.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
        return () => {
            autocompletionInput.current = null
        };
    }, []);
    useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };

    useEffect(() => {
        if (!places) return;
        const placeAutocomplete = new places.PlaceAutocompleteElement({
            includedPrimaryTypes: optionLocation,
            includedRegionCodes: countries
        })
        placeAutocomplete.addEventListener('gmp-select', async ({ placePrediction }) => {
            const place = placePrediction.toPlace();

            place.fetchFields({ fields: ['displayName', 'addressComponents', 'formattedAddress', 'location', 'types'] }).then(() => {
                //if (place.types.includes("premise") || place.types.includes("street_address")) {
                    console.log(place.toJSON());
                    const finalAddress = createAddressFromPlace(place);
                    if (props.setValueAddress) props.setValueAddress(finalAddress);
                    setAddressAutocompletion(finalAddress);
                //}
            });
        });
        autocompletionInput.current.appendChild(placeAutocomplete);

        return () => {
            if (placeAutocomplete) placeAutocomplete.remove();
        }

    }, [places]);

    useEffect(() => {
        if (!addressAutocompletion) return;
        //console.log(addressAutocompletion);
        if (data.onActionEvents && data.onActionEvents["onChange"]) {
            data.onActionEvents["onChange"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data, { value: addressAutocompletion })
                //    .then(actionResponse => {
                //    //console.debug(actionResponse);
                //    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                //        Swal.fire({
                //            icon: "error",
                //            title: "Echec",
                //            html: actionResponse.errorMessage
                //        });
                //    }
                //});
            });
        }
    }, [addressAutocompletion]);



    return (
        <div ref={autocompletionInput}></div>
    )
}

function createAddressFromPlace(place) {
    const placeJson = place.toJSON();
    const addressComponents = placeJson.addressComponents;
    const result = {}
    addressComponents.forEach((information) => {
        switch (true) {
            case information.types.includes("street_number"): {
                result.addressMain = (result.addressMain) ? information.longText + " " + result.addressMain : information.longText;
                break;
            }
            case information.types.includes("route"): {
                result.addressMain = (result.addressMain) ? result.addressMain + " " + information.longText : information.longText;
                break;
            }
            case information.types.includes("locality"): {
                result.city = information.longText
                break;
            }
            case information.types.includes("postal_code"): {
                result.pc = information.longText;
                break;
            }
            case information.types.includes("country"): {
                result.country = information.longText;
                break;
            }
            case information.types.includes("premise"): {
                result.addressPlus = information.longText;
                break;
            }
            case information.types.includes("subpremise"): {
                result.addressPlus2 = information.longText;
                break;
            }
            default:
                break;
        }
    })
    if (!result.addressPlus && result.addressPlus2) {
        result.addressPlus = result.addressPlus2;
        result.addressPlus2 = null;
    }
    if (!result.addressMain) {
        result.addressMain = result.addressPlus;
        result.addressPlus = null;
    }
    result.geoAddress = { geoLat: placeJson.location.lat, geoLon: placeJson.location.lng, geoSrc: "googleAutocomplete", isManual: false }
    result.type = "Preview";

    return result;
}


function AutoAddressFrag(props) {
    const { data, modelFctManager, parentProps, isConfiguration, parentDisabled } = props;//formManager bindPropResult childShouldRerender

    var frameClass = "";
    var frameStyle = {};

    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_autoAddress");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            var supBoxSize = modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
            frameClass += supBoxSize;
        }
        if (design.size || design.width) frameStyle.width = (design.size ? (design.size + "px") : design.width);
        if (design.maxWidth) frameStyle.maxWidth = design.maxWidth;
        if (design.height) {
            if (parseFloat(design.height.replace("px", "")) >= 0) {
                //TEMP : Gestion d�calage px/dp Android pour Home
                if (parentProps?.parentData?.groupSubName === "containerGroup" || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.groupSubName === "containerGroup") {
                    frameStyle.height = (parseFloat(design.height.replace("px", "")) * 2) + "px";
                }
                else {
                    frameStyle.height = design.height;
                }
            }
            else {
                frameClass += " h-100";
            }
        }

        Object.assign(frameStyle, modelFctManager.setCustomBackground(design, data));
        Object.assign(frameStyle, modelFctManager.managePadding(design, frameClass));
        Object.assign(frameStyle, modelFctManager.manageMargin(design, frameClass));
    }

    var disabled = (isConfiguration ? true : ((data.disabled ? true : false) || (!data.ignoreParentDisabled ? parentDisabled : false)));

    return <Col data-name="AutoAddressFrag" data-element={data.objType} xs="auto" className={`${frameClass}`} style={frameStyle} data-backimage={frameStyle.hasImage || null} data-imageopacity={frameStyle.alpha || null}>
        {disabled ? "" : <APIProvider region="FR" apiKey={API_KEY} libraries={["places"]}>
            <Autocompletion {...props}></Autocompletion>
        </APIProvider>}
    </Col>;
}

export default AutoAddressFrag